import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../../api/apiClient';
import { boardKeys } from './boardKeys';
import type { EventMarketsResponse } from '../../api/types';

const EMPTY: ReadonlyMap<string, string> = new Map();
const ONE_HOUR = 60 * 60 * 1000;

export function imagesByMarket(
    res: EventMarketsResponse | null | undefined
): ReadonlyMap<string, string> {
    if (!res?.markets) return EMPTY;
    const map = new Map<string, string>();
    for (const m of res.markets) {
        if (m.condition_id && m.image) map.set(m.condition_id, m.image);
    }
    return map;
}

export function useEventOutcomeImages(
    eventId: string | null,
    enabled = true
): ReadonlyMap<string, string> {
    const active = enabled && Boolean(eventId);
    const query = useQuery({
        queryKey: boardKeys.eventOutcomes(eventId ?? ''),
        queryFn: ({ signal }) =>
            apiGet<EventMarketsResponse>(
                `/api/event-markets/${encodeURIComponent(eventId as string)}`,
                signal
            ),
        enabled: active,
        staleTime: ONE_HOUR,
        gcTime: ONE_HOUR,
        retry: 1,
    });

    return useMemo(() => imagesByMarket(query.data), [query.data]);
}
